import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalService } from 'app/services/global.service';

@Component({
  selector: 'app-support-assign-tiket-quick-action',
  templateUrl: './support-assign-tiket-quick-action.component.html',
  styles: [
  ],
})
export class SupportAssignTiketQuickActionComponent implements OnInit{

  @Input() tickets: any[] = [];

  @Input() agents: any[] = [];


  selectedTicketId: string = '';

  selectedAgentId: number = null;


  ticketError = '';

  agentError = '';


  constructor(
    public activeModal: NgbActiveModal,
    public global: GlobalService
  ) {}


  ngOnInit(): void {

  }


  // =====================================================
  // SELECTED TICKET
  // =====================================================

  get selectedTicket(): any {

    return this.tickets.find(
      ticket =>
        ticket.ticketId ===
        this.selectedTicketId
    );

  }


  // =====================================================
  // CLEAR ERRORS
  // =====================================================

  clearErrors(): void {

    this.ticketError = '';

    this.agentError = '';

  }


  // =====================================================
  // TICKET CHANGE
  // =====================================================

  onTicketChange(): void {

    this.ticketError = '';

  }


  // =====================================================
  // AGENT CHANGE
  // =====================================================

  onAgentChange(): void {

    this.agentError = '';

  }


  // =====================================================
  // ASSIGN
  // =====================================================

  assignTicket(): void {

    this.clearErrors();


    if (!this.selectedTicketId) {

      this.ticketError =
        'Please select a ticket.';

      return;

    }


    if (!this.selectedAgentId) {

      this.agentError =
        'Please select an agent.';

      return;

    }


    this.activeModal.close({

      success: true,

      ticketId:
        this.selectedTicketId,

      agentId:
        this.selectedAgentId

    });

  }


  // =====================================================
  // CLOSE
  // =====================================================

  close(): void {

    this.activeModal.dismiss();

  }

}
